<template>
    <div class="d-flex flex-column modal-inner p-4 max-w-xxl">
        <div class="row mx-4 pb-1">
            <h3 class="m-0">Assigned Users</h3>
        </div>
        <div class="row mx-4 pb-1 mt-2">
            <vuetable
                ref="vuetable"
                :api-url="grid"
                :fields="fields"
                :css="css.table"
                :per-page="perPage"
                :append-params="moreParams"
                :data-path="'payload'"
                noDataTemplate="No Users Found"
                pagination-path=""
                @vuetable:pagination-data="onPaginationData"
                @vuetable:loaded="onLoaded"
                @vuetable:checkbox-toggled="onCheckbox"
                @vuetable:checkbox-toggled-all="onCheckboxAll"
            >
                <template slot="actions" slot-scope="props">
                    <div class="btn-group">
                        <a class="btn btn-sm btn-outline-secondary" :href="`/users/${props.rowData.id}/edit`">
                            <i class="fa fa-eye"></i>
                        </a>
                        <button class="btn btn-sm btn-danger" @click="handleDetachUser(props.rowData.id)">
                            <i class="fa fa-trash"></i>
                        </button>
                    </div>
                </template>
                <template slot="roles" slot-scope="props">
                    <div>
                        <a class="badge badge-primary"
                            v-for="role in props.rowData.roles"
                            :href="'/roles/' + role.id +'/edit/'"
                            :key="role.id"
                        >
                            {{ role.display_name }}
                        </a>
                    </div>
                </template>
                <template
                    slot="fullname"
                    slot-scope="props"
                >
                    {{ props.rowData.firstname }}
                    {{ props.rowData.lastname }}
                </template>
                <template slot="apikey" slot-scope="props">
                    <div class="badge-container">
                        <div v-if="props.rowData.oauth_access_token !=undefined"
                            class="badge badge-default"
                        >
                            Active
                        </div>
                        <div v-else
                            class="badge badge-default"
                        >
                            Inactive
                        </div>
                    </div>
                </template>
            </vuetable>
            <div class="row d-flex justify-content-between align-items-center w-100 m-auto">
                <span>
                    <base-pagination-info
                        :css="css.table"
                        ref="paginationInfo"
                    ></base-pagination-info>
                </span>
                <span>
                    <base-pagination
                        ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                    ></base-pagination>
                </span>
            </div>
        </div>
        <div class="row mx-4 my-0 pb-0">
            <div class="d-flex align-items-center">
                <button class="btn my-2 btn-outline-secondary" @click="handleClose">
                    Cancel
                </button>
                <button class="btn ml-2 btn-danger" :disabled="!pendingUsersToRemove.length" @click="handleDetachUsers">
                    Remove Selected Users
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import SelectItemFromAPIprovidedList from "../../generic/select-item-from-api-provided-list.vue";
import BasePagination from "../../tables/base-pagination.vue";
import BasePaginationInfo from "../../tables/base-pagination-info.vue";


const base_url = window.location.protocol + "//" + window.location.host;

export default {
    name: "workflow-restrict-user",
    components: {
        "selection-lister": SelectItemFromAPIprovidedList,
        "base-pagination": BasePagination,
        "base-pagination-info": BasePaginationInfo,
    },
    props: {
        isProject: {
            type: [Boolean],
            default: true
        },
        projectWorkflowId: {
            type: [Number, String],
            required: true
        }
    },
    data() {
        return {
            pendingUsersToRemove: [],
            perPage: 5,
            moreParams: {},
            loading: true,
            fields: [
                {
                    name: "__checkbox",
                    titleClass: 'center aligned',
                    dataClass: 'right aligned'
                },
                {
                    name: "__slot:fullname",
                    sortField: "firstname",
                    title: "Full Name",
                },
                {
                    name: "email",
                    title: "Email Address",
                    callback: "linkEmail",
                },
                {
                    name: "__slot:roles",
                    title: "Roles",
                },
                {
                    name: "__slot:actions",
                    titleClass: "actions-single-column",
                },
            ],
            grid: `${base_url}/pimapi/${this.isProject ? 'projects' : 'workflows '}/${this.projectWorkflowId}/users`,
            css: {
                table: {
                    tableClass:
                        "table table-striped table-bordered table-middle",
                    ascendingIcon: "sort-icon-asc",
                    descendingIcon: "sort-icon-desc",
                    infoClass: "",
                },
            },
        }
    },
    computed: {},
    methods: {
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        onLoaded: function () {
            this.loading = false;
        },
        onCheckbox(isChecked, row) {
            if (isChecked) {
                this.pendingUsersToRemove.push(row);
            } else {
                this.pendingUsersToRemove = 
                    this.pendingUsersToRemove.filter((pendingUser) => pendingUser.id !== row.id);
            }
        },
        onCheckboxAll(isChecked) {
            if (isChecked === false) {
                this.$refs.vuetable.selectedTo = [];
                this.pendingUsersToRemove = [];
            } else {
                let selected = this.$refs.vuetable.tableData.map(item => item);
                this.pendingUsersToRemove = this.pendingUsersToRemove.concat(selected);
            }
        },
        handleDetachUser(id) {
            axios
                .post("/pimapi/projects/" + this.projectWorkflowId + "/users/detach", {
                    userIds: [id]
                })
                .then((response) => {
                    console.log(response)

                    this.handleAlert({
                        status: "alert-success",
                        message: "User removed",
                    });

                    this.$refs.vuetable.refresh();
                })
                .catch((err) => {
                    console.log(err);

                    this.pendingUsersToRemove = [];
                    this.handleAlert({
                        status: "alert-danger",
                        message: err.response.data.message,
                    });
                })
        },
        handleDetachUsers() {
            axios
                .post("/pimapi/projects/" + this.projectWorkflowId + "/users/detach", {
                    userIds: this.pendingUsersToRemove
                })
                .then((response) => {
                    console.log(response)

                    this.handleAlert({
                        status: "alert-success",
                        message: "Users removed",
                    });

                    this.pendingUsersToRemove = [];
                    this.$refs.vuetable.refresh();
                })
                .catch((err) => {
                    console.log(err);
                    this.pendingUsersToRemove = [];

                    this.handleAlert({
                        status: "alert-danger",
                        message: err.response.data.message,
                    });
                })
        },
        handleClose() {
            this.$parent.assignedUsersModal = false;
        },
        handleAlert(alert) {
            this.$parent.$parent.alert = alert;
        }

    }
}
</script> 